var map = {
	"./01_tag_free-wifi.svg": 481,
	"./02_tag_free-parking.svg": 482,
	"./03_tag_paid-parking.svg": 483,
	"./04_tag_indoor-pool.svg": 484,
	"./05_tag_outdoor-pool-in-summer.svg": 485,
	"./06_tag_beach.svg": 486,
	"./07_tag_large-public-bath.svg": 487,
	"./08_tag_hot-spring.svg": 488,
	"./09_tag_spa.svg": 489,
	"./10_tag_outdoor-bath.svg": 490,
	"./11_tag_non-smoking.svg": 491,
	"./12_tag_convenience-store.svg": 492,
	"./13_tag_restaurant.svg": 493,
	"./14_tag_connecting-room.svg": 494,
	"./15_tag_with-kitchen.svg": 495,
	"./16_tag_kitchen.svg": 496,
	"./17_tag_fitness-gym.svg": 497,
	"./18_tag_paid-massage-service.svg": 498,
	"./19_tag_paid-beauty-salon.svg": 499,
	"./20_tag_vending-machine.svg": 500,
	"./21_tag_kitchenware-tableware.svg": 501,
	"./22_tag_washing-machine.svg": 502,
	"./23_tag_clothes-dryer.svg": 503,
	"./24_tag_paid-coin-laundry.svg": 504,
	"./25_tag_courtesy-bus.svg": 505,
	"./26_tag_lounge.svg": 506,
	"./27_tag_bbq-garden.svg": 507,
	"./28_tag_induction-cooker.svg": 135,
	"./29__tag_microwave.svg": 259,
	"./30_tag_smoking-area.svg": 508,
	"./31_tag_pet-friendly.svg": 509,
	"./tag_convenience-store.svg": 510,
	"./tag_free-parking.svg": 511,
	"./tag_free-wifi.svg": 512,
	"./tag_outdoor-pool-in-summer.svg": 513,
	"./tag_paid-coin-laundry.svg": 514,
	"./tag_restaurant.svg": 515,
	"./tag_vending-machine.svg": 516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;